// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"az_Lk","topHrTag":"az_Mk","bottomHrTag":"az_Nk","linksAndCookieBtn":"az_Ok"};